import { gql } from '@apollo/client';

export const GET_TOP_PRICE_LABELS = gql`
  query GetTopPriceLabels($filters: DistributionGraphsInput) {
    getTopPriceLabels(input: $filters) {
      amountOfListings
      label
    }
  }
`;
